import React from 'react';
import { Dropdown } from 'semantic-ui-react';

function BatteryStatusDropDown({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  batteryStatusData,
  ...props
}) {

  const Options = []
  if (batteryStatusData && batteryStatusData.length > 0) {
    batteryStatusData.map((object, index) => {
      let temp = {}
      temp.key = object.batteryStatusId
      temp.text = object.batteryStatus
      temp.value = object.batteryStatusId
      return Options[index] = temp
    })
  }

  const handleChange = (e, data) => {
    setFieldValue(name, data.value);
  }

  return (
    <Dropdown
      selection
      placeholder="Battery Status"
      search
      onChange={handleChange}
      options={Options}
      scrolling={true}
      {...props}
    />
  )
}

export default BatteryStatusDropDown